import * as d3 from 'd3';
export var ColorMixin = function ColorMixin(chart, props) {
  var colorAccessor = props.colorAccessor,
      colors = props.colors;

  if (typeof colorAccessor === 'function') {
    chart.colorAccessor(colorAccessor);
  }

  if (typeof colors === 'function') {
    chart.colors(colors);
  } else if (Array.isArray(colors)) {
    chart.colors(d3.scaleOrdinal().range(d3.schemeTableau10));
  }

  return chart;
};